import React from "react"

let PageContent = {
    Hero:{
        Title:<>50 Reasons to Love</>,
        TitleLarge:{
            mobile:"hero-mobile.json",
            desktop:"hero-desktop.json",
            tablet:"hero-tablet.json"
        },
        intro:"BBC Travel celebrates 50 Reasons to Love the World in 2021, through the inspiration of well-known voices as well as unsung heroes in local communities around the globe.",
        heroImages:[
            {
                image:"Image_1.jpg",
                alt:"In Bhutan, fermented dough soon becomes spools of soft incense"
            },
            {
                image:"Image_3.jpg",
                alt:"Novaling is sharing the tradition of Inuit throat singing for a new generation"
            },
            {
                image:"Image_2.jpg",
                alt:"Aurora Borealis"
            },
            {
                image:"Image_6.jpg",
                alt:"For famed ecologist Vandana Shiva, what we eat is a matter of life and death"
            },
            {
                image:"Image_4.jpg",
                alt:"Penguin on some grass"
            },
            {
                image:"Image_5.jpg",
                alt:"Char kway teow is Malaysia’s most famous street food"
            }
        ]
    },
    HeroText:{
        titleLine1:"New year,",
        titleLine2:"New hope",
        text:<><p>It goes without saying that the world was turned upside-down last year as we faced a global pandemic, racial reckoning and the continued effects of climate change. However, we at BBC Travel believe the dawn of 2021 brings with it a new sense of hope and possibility – as well as a heightened sense of connection to each other and the world around us.</p><p>Even as we were – and still are – unable to travel in the way we did before the pandemic, people from different cultures in every continent have continued to thrive in their personal corners of the planet, bringing joy, passion and inspiration to their communities. They've preserved local traditions, made strides to protect the Earth, and used their creative talents to expand and evolve their cultures.</p><p>With BBC Travel's 50 Reasons to Love the World in 2021, we hope to share that joy with you, and through their extraordinary stories, inspire you to fall in love with the world all over again. After all, it's the only one we have.</p><p> We asked 50 remarkable people – both known voices and unsung heroes – the question, “Why do you love the world?” Scroll to discover what they had to say…</p></>,
        background:{
            poster:{
                mobile: "hero-poster-desktop.jpg",
                tablet: "hero-poster-desktop.jpg",
                desktop: "hero-poster-desktop.jpg",
            },
            video:{
                mobile: "Delta_Ambient.mp4",
                tablet: "Delta_Ambient.mp4",
                desktop: "Delta_Ambient.mp4",
            }
        },
    },
    LatestContent:{
        ctaText:"Read more",
        heroArticle:{
            heading:"Spain | Sustainability",
            title:"Spain's underwater 'super plant'",
            ctaURL:"http://www.bbc.com/travel/article/20210204-posidonia-the-mediterraneans-super-plant",
            mobileImage:"Spainsunderwatersuperplant.jpg",
            desktopImage:"SpainsunderwatersuperplantDesktop.jpg",
            imageAlt:"Formentera boasts some of the most spectacular beaches of the world",
        },
        articles:[
            {
                heading:"Saudi Arabia | Culture",
                title:"Saudi's lineage of interior stylists",
                ctaURL:"https://www.bbc.com/travel/article/20211122-saudis-lineage-of-interior-stylists",
                image:"saudi_arabia-saudi-lineage.jpg",
                imageAlt:"Chauris have been vital to the livelihoods of nomadic communities in the Himalayas"
            },
            {
                heading:"Nepal | Food & Drink",
                title:"The world's hardest cheese?",
                ctaURL:"https://www.bbc.com/travel/article/20211005-chhurpi-the-worlds-hardest-cheese",
                image:"theworldshardestcheese.jpg",
                imageAlt:"Chauris have been vital to the livelihoods of nomadic communities in the Himalayas"
            },
            {
                heading:"Egypt | Language",
                title:"A revival of Egypt's Nubian culture",
                ctaURL:"https://www.bbc.com/travel/article/20210922-a-revival-of-egypts-nubian-culture",
                image:"arevivalofegyptsnubianculture.jpg",
                imageAlt:"A guesthouse on Elephantine Island holds treasures of Nubian culture"
            }
        ]
    },
    Quote:{
        quoteMarks:"quoteMarks.svg",
        backgroundImage:{
            mobile:"Quote_Image_Mobile.jpg",
            tablet:"Quote_Image_Tablet.jpg",
            desktop:"Quote_Image_Desktop.jpg"
        },
        imageAlt:"Novaling is sharing the tradition of Inuit throat singing for a new generation",
        quote:'"Because of all of our differences. We each have our culture, our identity, our story..."',
        biline:"Shina Novalinga, throat singer",
        ctaText:"Discover more",
        ctaUrl:"https://www.bbc.com/travel/gallery/20210104-50-reasons-to-love-the-world--2021-edition"
    },
    Map:{
        image:{
            mobile:"Map_BG_Image.jpg",
            tablet:"Map_BG_Image.jpg",
            desktop:"Map_BG_Image.jpg"
        },
        mapPins:[
            {
                location:"Tahiti | Cultural Traditions",
                title:"The sacred Polynesian art of wayfinding",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210726-polynesias-master-voyagers-who-navigate-by-nature",
                image:"ThesacredPolynesianartofwayfinding.jpg",
                imageAlt:"The name Hōkūle‘a painted on the hull of the Polynesian double-hulled sailing canoe",
                position:{
                    x:312,
                    y:660

                }
            },
            {
                location: "US | Sustainability",
                title: "The US' remote northern outpost",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210215-welcome-to-polebridge-one-of-the-us-last-frontiers",
                image:"The-US-remote-northernoutpost.jpg",
                imageAlt:'Residents worry that as people "discover" Polebridge, the environment will suffer',
                position:{
                    x:412,
                    y:149

                }
            },
            {
                location: "US | Nature & Outdoors",
                title: "The guardian of Colorado's Front Range",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210809-the-guardian-of-colorados-front-range",
                image:"TheguardianofColoradosFrontRange.jpg",
                imageAlt:'Front Range makes up the easternmost edge of the Rocky Mountains',
                position:{
                    x:437,
                    y:230

                }
            },
            {
                location: "Canada | Cultural Traditions",
                title: "Canada's rising Inuit TikTok star",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210414-a-revival-of-indigenous-throat-singing",
                image:"Canadas-rising-Inuit-TikTok-star.jpg",
                imageAlt:'Novaling is sharing the tradition of Inuit throat singing for a new generation',
                position:{
                    x:689,
                    y:237

                }
            },
            {
                location:"Bahamas | Cultural Traditions",
                title:"The Bahamas' queen of Junkanoo",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210818-the-bahamas-queen-of-junkanoo",
                image:"TheBahamasqueenofJunkanoo.jpg",
                imageAlt:"Historian Arlene Nash Ferguson has turned her home into the Educulture Junkanoo Museum",
                position:{
                    x:664,
                    y:361

                }
            },
            {
                location: "Cuba | Culture",
                title: "The world traveller who never left home",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210114-the-bus-porter-who-travelled-the-world",
                image:"The-world-traveller-who-never-left-home.jpg",
                imageAlt:"Luis Martinez, Cuba's 'imaginary tourist'",
                position:{
                    x:661,
                    y:386

                }
            },
            {
                location:"Mexico | Cultural Traditions",
                title:"The man preserving endangered colours",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210823-the-man-preserving-endangered-colours",
                image:"Themanpreservingendangeredcolours.jpg",
                imageAlt:"Teotitlán del Valle is home to generations of indigenous Zapotec weavers" ,
                position:{
                    x:531,
                    y:417

                }
            },
            {
                location:"Grenada | Adventure",
                title:"The 'Indiana Jones' of the Caribbean",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210408-the-man-mapping-a-nation-by-hand-telfor-bedeau",
                image:"TheIndianaJonesoftheCaribbean.jpg",
                imageAlt:"A lagoon with small waterfall, Annandale Falls, in St Georges, Grenada",
                position:{
                    x:773,
                    y:450

                }
            },
            {
                location:"Colombia | Sustainability",
                title:"The indigenous recipe for living well",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210207-buen-vivir-colombias-philosophy-for-good-living",
                image:"Theindigenousrecipeforlivingwell.jpg",
                imageAlt:"Colombian Indigenous groups incorporate the philosophy of Buen Vivir",
                position:{
                    x:689,
                    y:519

                }
            },
            {
                location:"Peru | Adventure",
                title:"Machu Picchu's trailblazing women",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210803-the-women-porters-making-history-on-perus-inca-trail",
                image:"MachuPicchustrailblazingwomen.jpg",
                imageAlt:"Trailblazing women of Machu Picchu",
                position:{
                    x:699,
                    y:620

                }
            },
            {
                location:"Chile | Nature & Outdoors",
                title:"Chile's 'hidden kingdom' of fungi",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210811-the-chilean-biologist-celebrating-fungis-hidden-kingdom",
                image:"Chileshiddenkingdomoffungi.jpg",
                imageAlt:"Close-up of a Cyttaria hariotii, also known as llao llao mushroom",
                position:{
                    x:710,
                    y:757

                }
            },
            {
                location:"South Africa | Sustainability",
                title:"A nation without access to its own sea",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210304-can-hanli-prinsloo-help-south-africa-reclaim-its-oceans",
                image:"Anationwithoutaccesstoitsownsea.jpg",
                imageAlt:"Hanli Prinsloo has broken 11 South African freediving records",
                position:{
                    x:1350,
                    y:735

                }
            },
            {
                location:"Zimbabwe | Nature",
                title:"Zimbabwe's revered 'nest custodians'",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210728-the-nest-custodians-protecting-a-toddler-sized-bird",
                image:"Zimbabwesreverednestcustodians.jpg",
                imageAlt:"Colourful sunrise over the hills and savanna in Matobo Hills National Park",
                position:{
                    x:1405,
                    y:665

                }
            },
            {
                location:"Rwanda | Food & Drink",
                title:"Where people go to bars to drink milk",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210323-where-people-go-to-bars-to-drink-milk",
                image:"Wherepeoplegotobarstodrinkmilk.jpg",
                imageAlt:"Yusuf Gatikabisi owns Kuruhimbi milk bar in Rwanda",
                position:{
                    x:1395,
                    y:550

                }
            },
            {
                location:"Tunisia | Food & Hospitality",
                title:"The couscous meal that feeds generosity",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210816-house-of-bennani-the-library-of-the-habous-of-couscous",
                image:"Thecouscousmealthatfeedsgenerosity.jpg",
                imageAlt:"Couscous is considered Tunisia's most iconic dish",
                position:{
                    x:1259,
                    y:290

                }
            },
            {
                location:"Canary Islands | Culture",
                title:"A tiny isle with an 'unspoken' language",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210720-the-spanish-island-that-communicates-by-whistle",
                image:"Atinyislewithanunspokenlanguage.jpg",
                imageAlt:"Two boys whistling in the Barranco de Ávalo ravine, La Gomera",
                position:{
                    x:1069,
                    y:342

                }
            },
            {
                location:"Spain | Sustainability",
                title:"Spain's underwater 'super plant'",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210204-posidonia-the-mediterraneans-super-plant",
                image:"Spainsunderwatersuperplant.jpg",
                imageAlt:"Formentera boasts some of the most spectacular beaches of the world",
                position:{
                    x:1203,
                    y:270

                }
            },
            {
                location:"Scotland | Cultural Traditions",
                title:"Scotland's little-known Highlanders",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210222-ghillies-scotlands-little-known-highlanders",
                image:"ScotlandslittleknownHighlanders.jpg",
                imageAlt:"The Scottish Highlands are holiday hotspot for adventures led by ghillies",
                position:{
                    x:1162,
                    y:145

                }
            },
            {
                location:"Svalbard | Sustainability",
                title:"A defiant move to the Norwegian Arctic",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210120-a-defiant-move-to-the-norwegian-arctic",
                image:"AdefiantmovetotheNorwegianArctic.jpg",
                imageAlt: "During their months of isolation, the polar night produced some glorious sights",
                position:{
                    x:1240,
                    y:123

                }
            },
            {
                location:"Sweden | Cultural Traditions",
                title:"A hypnotic Swedish tradition",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210106-kulning-a-hypnotic-swedish-singing-tradition",
                image:"AhypnoticSwedishtradition.jpg",
                imageAlt:"Summer farms are inextricably linked to the ancient Swedish singing tradition of kulning",
                position:{
                    x:1300,
                    y:110

                }
            },
            {
                location:"Slovenia | Food & Drink",
                title:"The chef who put Slovenia on the map",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210211-ana-ros-the-chef-who-put-slovenia-on-the-map",
                image:"ThechefwhoputSloveniaonthemap.jpg",
                imageAlt:"Ana Roš cooks with herbs and spices harvested from Hiša Franko’s own garden",
                position:{
                    x:1290,
                    y:220

                }
            },
            {
                location:"Albania | Nature & Outdoors",
                title:"The European nation keeping us 'young'",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210706-the-albanian-mountain-crops-that-keep-us-looking-young",
                image:"TheEuropeannationkeepingusyoung.jpg",
                imageAlt:"Albanian wild-gathered herbs are sought-after internationally",
                position:{
                    x:1335,
                    y:253

                }
            },
            {
                location:"Russia | Food & Drink",
                title:"The Russian town built by apples",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210125-kolomna-the-russian-town-built-by-apple-sweets",
                image:"TheRussiantownbuiltbyapples.jpg",
                imageAlt:"Natalia Nikitina is hoping to bring back Russia's heritage apple varieties such the Arkad",
                position:{
                    x:1373,
                    y:175

                }
            },
            {
                location:"India | Sustainability",
                title:"One village's dramatic transformation",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210302-piplantri-the-indian-village-where-girls-rule",
                image:"Onevillagesdramatictransformation.jpg",
                imageAlt:"Today, more girls attend the local school than boys do in Indian villages like Piplantri",
                position:{
                    x:1725,
                    y:412

                }
            },
            {
                location:"Bhutan | Wellness",
                title:"A tightly guarded Himalayan secret",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210331-bhutans-350-year-old-recipe-for-wellbeing",
                image:"AtightlyguardedHimalayansecret.jpg",
                imageAlt:"In Bhutan, fermented dough soon becomes spools of soft incense",
                position:{
                    x:1811,
                    y:354

                }
            }, 
            {
                location:"Cambodia | Cultural Traditions",
                title:"A rare silk nearly lost through war",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210620-the-ancient-cambodian-silk-that-was-almost-lost",
                image:"A_rare_silk_nearly_lost_through_war.jpg",
                imageAlt:"Ikat weaving from Cambodia's unique golden silk dates back more than 1,000 years",
                position:{
                    x:1890,
                    y:440

                }
            },
            {
                location:"Malaysia | Food & Drink",
                title:"Malaysia’s humble ‘king of noodles’",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210118-why-noodles-are-malaysias-most-famous-street-food",
                image:"Malaysiashumblekingofnoodles.jpg",
                imageAlt:"Char kway teow is Malaysia’s most famous street food",
                position:{
                    x:1885,
                    y:500

                }
            }, 
            {
                location:"Hong Kong | Cultural Traditions",
                title:"Hong Kong's guardian of the gods",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210202-hong-kongs-guardian-of-the-gods",
                image:"HongKongsguardianofthegods.jpg",
                imageAlt:"Wong and this vast outdoor shrine remain relatively unknown to most Hongkongers",
                position:{
                    x:1978,
                    y:377

                }
            }, 
            {
                location:"Australia | Sustainability",
                title:"The poster boy of zero-waste living",
                lernMoreUrl:"https://www.bbc.com/travel/article/20210629-joost-bakker-on-why-zero-waste-living-is-the-future",
                image:"Theposterboyofzero-wasteliving.jpg",
                imageAlt:"Zero-waste activist Joost Bakker",
                position:{
                    x:2230,
                    y:754

                }
            },
            {
                location:"New Zealand | Sustainability",
                title:"New Zealand's feisty, feathered patient",
                lernMoreUrl:"http://www.bbc.com/travel/article/20210422-new-zealands-endangered-penguin-hospital",
                image:"New_Zealands_feisty_feathered_patient.jpg",
                imageAlt:"The yellow-eyed penguin, or hoiho, is on New Zealand's endangered list",
                position:{
                    x:2352,
                    y:844

                }
            },
            
        ]
    },
    Carousel:{ 
        ctaText:"Read more",
        articles:[
            {
                heading:"Grenada | Adventure",
                title:"The 'Indiana Jones' of the Caribbean",
                ctaURL:"http://www.bbc.com/travel/article/20210408-the-man-mapping-a-nation-by-hand-telfor-bedeau",
                image:"TheIndianaJonesoftheCaribbean.jpg",
                imageAlt:"A lagoon with small waterfall, Annandale Falls, in St Georges, Grenada"
            },
            {
                heading:"US | Food & Drink",
                title:"The crucial legacy missing from US food",
                ctaURL:"http://www.bbc.com/travel/article/20210406-the-crucial-legacy-missing-from-us-food",
                image:"ThecruciallegacymissingfromUSfood.jpg",
                imageAlt:"Piñon nut torte is a signature dish for the feast days of New Mexico's Indian Pueblos"
            },
            {
                heading:"World | Adventure",
                title:"A 33,000km walk from humans' birthplace",
                ctaURL:"http://www.bbc.com/travel/article/20210329-the-war-correspondent-walking-the-world",
                image:"A33000kmwalkfromhumansbirthplace.jpg",
                imageAlt:"Saudi Arabia's ancient Nabataean ruins of Madain Salih"
            },
            {
                heading:"Sweden | Food & Drink",
                title:"The Swedish chef who reinvented fire",
                ctaURL:"http://www.bbc.com/travel/article/20210325-the-swedish-chef-who-cooks-solely-with-fire",
                image:"TheSwedishchefwhoreinventedfire.jpg",
                imageAlt:"Ekstedt brought childhood memories of being out in the woods into a restaurant setting"
            },
            {
                heading:"Rwanda | Food & Drink",
                title:"Where people go to bars to drink milk",
                ctaURL:"http://www.bbc.com/travel/article/20210323-where-people-go-to-bars-to-drink-milk",
                image:"Wherepeoplegotobarstodrinkmilk.jpg",
                imageAlt:"Yusuf Gatikabisi owns Kuruhimbi milk bar in Rwanda"
            },
            {
                heading:"Tanzania | Sustainability",
                title:"Jane Goodall's reasons to be hopeful",
                ctaURL:"http://www.bbc.com/travel/article/20210318-why-jane-goodall-is-hopeful-in-2021",
                image:"JaneGoodallsreasonstobehopeful.jpg",
                imageAlt:"Jane Goodall says is its extremely important to restore forests"
            },
            {
                heading:"Bolivia | Cultural Traditions",
                title:"One of the Americas' last kingdoms",
                ctaURL:"http://www.bbc.com/travel/article/20210310-bolivias-little-known-tribal-kingdom",
                image:"OneoftheAmericaslastkingdoms.jpg",
                imageAlt:"Nestled in the Yungas valley, Mururata is the centre of the Kingdom of the Afro-Bolivians"
            }
        ]
    },
    PromoContent:{
        ctaText:"Read more",
        heroArticle:{
            heading:"Bhutan | Wellness",
            title:"A tightly guarded Himalayan secret",
            ctaURL:"http://www.bbc.com/travel/article/20210331-bhutans-350-year-old-recipe-for-wellbeing",
            mobileImage:"AtightlyguardedHimalayansecret.jpg",
            desktopImage:"AtightlyguardedHimalayansecretDesktop.jpg",
            imageAlt:"In Bhutan, fermented dough soon becomes spools of soft incense",
        }
    },
    MoreContent:{
        ctaText:"Read more",
        articles:[
            {
                heading:"Australia | Nature & Outdoors",
                title:"The keepers of the Outback's secrets",
                ctaURL:"https://www.bbc.com/travel/article/20210914-the-indigenous-keeper-of-the-outbacks-secrets",
                image:"thekeepersoftheoutbackssecrets.jpg",
                imageAlt:"Salt lake and sand dunes in Western Australia's Great Sandy Desert"
            },
            {
                heading:"Kenya | Cultural Traditions",
                title:"Kenya's newfound lion protectors  ",
                ctaURL:"https://www.bbc.com/travel/article/20210913-where-people-live-in-harmony-with-lions",
                image:"Kenyasnewfoundlionprotectors.jpg",
                imageAlt:"Maasai tribesmen with Mount Kilimanjaro on the background, Kenya"
            },
            {
                heading:"Palestinian territories | Sustainabilitys",
                title:"The woman saving Palestinian food",
                ctaURL:"https://www.bbc.com/travel/article/20210908-the-woman-saving-palestinian-heirloom-seeds",
                image:"thewomansavingpalestinianfood.jpg",
                imageAlt:"A Palestinian farmer uses a sieve to separate sesame seeds from stems"
            },
            {
                heading:"Mali | Cultural Traditions",
                title:"The nomad guide who decodes the Sahara ",
                ctaURL:"https://www.bbc.com/travel/article/20210906-the-nomad-guide-who-decodes-the-saharas-secrets",
                image:"thenomadguidewhodecodesthesahara.jpg",
                imageAlt:"Man in blue robes walking in the Saharan Desert town of Araouane"
            },
            {
                heading:"Mexico | Cultural Traditions",
                title:"The man preserving endangered colours",
                ctaURL:"https://www.bbc.com/travel/article/20210823-the-man-preserving-endangered-colours",
                image:"Themanpreservingendangeredcolours.jpg",
                imageAlt:"Teotitlán del Valle is home to generations of indigenous Zapotec weavers"
            },
            {
                heading:"Bahamas | Cultural Traditions",
                title:"The Bahamas' queen of Junkanoo",
                ctaURL:"https://www.bbc.com/travel/article/20210818-the-bahamas-queen-of-junkanoo",
                image:"TheBahamasqueenofJunkanoo.jpg",
                imageAlt:"Historian Arlene Nash Ferguson has turned her home into the Educulture Junkanoo Museum"
            },
            {
                heading:"Tunisia | Food & Hospitality",
                title:"The couscous meal that feeds generosity",
                ctaURL:"https://www.bbc.com/travel/article/20210816-house-of-bennani-the-library-of-the-habous-of-couscous",
                image:"Thecouscousmealthatfeedsgenerosity.jpg",
                imageAlt:"Couscous is considered Tunisia's most iconic dish"
            },
            {
                heading:"Chile | Nature & Outdoors",
                title:"Chile's 'hidden kingdom' of fungi",
                ctaURL:"https://www.bbc.com/travel/article/20210811-the-chilean-biologist-celebrating-fungis-hidden-kingdom",
                image:"Chileshiddenkingdomoffungi.jpg",
                imageAlt:"Close-up of a Cyttaria hariotii, also known as llao llao mushroom"
            },
            {
                heading:"US | Nature & Outdoors",
                title:"The guardian of Colorado's Front Range",
                ctaURL:"https://www.bbc.com/travel/article/20210809-the-guardian-of-colorados-front-range",
                image:"TheguardianofColoradosFrontRange.jpg",
                imageAlt:"Front Range makes up the easternmost edge of the Rocky Mountains"
            },
            {
                heading:"Peru | Adventure",
                title:"Machu Picchu's trailblazing women",
                ctaURL:"https://www.bbc.com/travel/article/20210803-the-women-porters-making-history-on-perus-inca-trail",
                image:"MachuPicchustrailblazingwomen.jpg",
                imageAlt:"Trailblazing women of Machu Picchu"
            },
            {
                heading:"Zimbabwe | Nature",
                title:"Zimbabwe's revered 'nest custodians'",
                ctaURL:"https://www.bbc.com/travel/article/20210728-the-nest-custodians-protecting-a-toddler-sized-bird",
                image:"Zimbabwesreverednestcustodians.jpg",
                imageAlt:"Colourful sunrise over the hills and savanna in Matobo Hills National Park"
            },
            {
                heading:"Tahiti | Cultural Traditions",
                title:"The sacred Polynesian art of wayfinding",
                ctaURL:"https://www.bbc.com/travel/article/20210726-polynesias-master-voyagers-who-navigate-by-nature",
                image:"ThesacredPolynesianartofwayfinding.jpg",
                imageAlt:"The name Hōkūle‘a painted on the hull of the Polynesian double-hulled sailing canoe"
            },
            {
                heading:"Canary Islands | Culture",
                title:"A tiny isle with an 'unspoken' language",
                ctaURL:"https://www.bbc.com/travel/article/20210720-the-spanish-island-that-communicates-by-whistle",
                image:"Atinyislewithanunspokenlanguage.jpg",
                imageAlt:"Two boys whistling in the Barranco de Ávalo ravine, La Gomera"
            },
            {
                heading:"US | Nature & Outdoors",
                title:"The world's most endangered sound",
                ctaURL:"https://www.bbc.com/travel/article/20210712-the-worlds-most-endangered-sound",
                image:"Theworldsmostendangeredsound.jpg",
                imageAlt:"Gordon Hempton records sound in a clearing in the Hoh Rainforest"
            },
            {
                heading:"Albania | Nature & Outdoors",
                title:"The European nation keeping us 'young'",
                ctaURL:"https://www.bbc.com/travel/article/20210706-the-albanian-mountain-crops-that-keep-us-looking-young",
                image:"TheEuropeannationkeepingusyoung.jpg",
                imageAlt:"Albanian wild-gathered herbs are sought-after internationally"
            },
            {
                heading:"Australia | Sustainability",
                title:"The poster boy of zero-waste living",
                ctaURL:"https://www.bbc.com/travel/article/20210629-joost-bakker-on-why-zero-waste-living-is-the-future",
                image:"Theposterboyofzero-wasteliving.jpg",
                imageAlt:"Zero-waste activist Joost Bakker" 
            },
            {
                heading:"Cambodia | Cultural Traditions",
                title:"A rare silk nearly lost through war",
                ctaURL:"https://www.bbc.com/travel/article/20210620-the-ancient-cambodian-silk-that-was-almost-lost",
                image:"A_rare_silk_nearly_lost_through_war.jpg",
                imageAlt:"Ikat weaving from Cambodia's unique golden silk dates back more than 1,000 years" 
            },
            {
                heading:"New Zealand | Sustainability",
                title:"New Zealand's feisty, feathered patient",
                ctaURL:"http://www.bbc.com/travel/article/20210422-new-zealands-endangered-penguin-hospital",
                image:"New_Zealands_feisty_feathered_patient.jpg",
                imageAlt:"The yellow-eyed penguin, or hoiho, is on New Zealand's endangered list"
            },
            {
                heading:"Slovakia | Cultural Traditions",
                title:"The extreme life of Europe's sherpas",
                ctaURL:"http://www.bbc.com/travel/article/20210420-the-last-sherpas-of-europe",
                image:"The_extreme_life_of_Europes_sherpas.jpg",
                imageAlt:"Mountain huts or chalets provide refreshments and overnight accommodation for hikers"
            },
            {
                heading:"Canada | Cultural Traditions",
                title:"Canada's rising Inuit TikTok star",
                ctaURL:"http://www.bbc.com/travel/article/20210414-a-revival-of-indigenous-throat-singing",
                image:"Canadas_rising_Inuit_TikTok_star.jpg",
                imageAlt:"Novaling is sharing the tradition of Inuit throat singing for a new generation"
            },
            {
                heading:"US | Food & Drink",
                title:"How rice shaped the American South",
                ctaURL:"http://www.bbc.com/travel/article/20210307-how-rice-shaped-the-american-south",
                image:"HowriceshapedtheAmericanSouth.jpg",
                imageAlt:"Enslaved Africans morphed West African recipes to suit the plantation world"
            },
            {
                heading:"South Africa | Sustainability",
                title:"A nation without access to its own sea",
                ctaURL:"http://www.bbc.com/travel/article/20210304-can-hanli-prinsloo-help-south-africa-reclaim-its-oceans",
                image:"Anationwithoutaccesstoitsownsea.jpg",
                imageAlt:"Hanli Prinsloo has broken 11 South African freediving records"
            },
            {
                heading:"India | Sustainability",
                title:"One village's dramatic transformation",
                ctaURL:"http://www.bbc.com/travel/article/20210302-piplantri-the-indian-village-where-girls-rule",
                image:"Onevillagesdramatictransformation.jpg",
                imageAlt:"Today, more girls attend the local school than boys do in Indian villages like Piplantri"
            },
            {
                heading:"Belgium | Cultural Traditions",
                title:"Where horses plough the sea for food",
                ctaURL:"http://www.bbc.com/travel/article/20210224-europes-500-year-old-seafood-tradition",
                image:"Wherehorsesploughtheseaforfood.jpg",
                imageAlt:"For the past 500 years, shrimp fishing has been passed down from fathers to sons"
            },
            {
                heading:"Scotland | Cultural Traditions",
                title:"Scotland's little-known Highlanders",
                ctaURL:"https://www.bbc.com/travel/article/20210222-ghillies-scotlands-little-known-highlanders",
                image:"ScotlandslittleknownHighlanders.jpg",
                imageAlt:"The Scottish Highlands are holiday hotspot for adventures led by ghillies"
            },
            {
                heading:"Italy | Culture",
                title:"The allure of Frances Mayes' Italy",
                ctaURL:"http://www.bbc.com/travel/article/20210218-italys-best-forgotten-cities-and-towns",
                image:"TheallureofFrancesMayesItaly.jpg",
                imageAlt:"Rome's Trevi Fountain was designed by Italian architect Nicola Salvi"
            },
            {
                heading:"US | Sustainability",
                title:"The US' remote northern outpost",
                ctaURL:"http://www.bbc.com/travel/article/20210215-welcome-to-polebridge-one-of-the-us-last-frontiers",
                image:"TheUSremotenorthernoutpost.jpg",
                imageAlt:'Residents worry that as people "discover" Polebridge, the environment will suffer'
            },
            {
                heading:"Slovenia | Food & Drink",
                title:"The chef who put Slovenia on the map",
                ctaURL:"http://www.bbc.com/travel/article/20210211-ana-ros-the-chef-who-put-slovenia-on-the-map",
                image:"ThechefwhoputSloveniaonthemap.jpg",
                imageAlt:"Ana Roš cooks with herbs and spices harvested from Hiša Franko’s own garden"
            },
            {
                heading:"Colombia | Sustainability",
                title:"The indigenous recipe for living well",
                ctaURL:"http://www.bbc.com/travel/article/20210207-buen-vivir-colombias-philosophy-for-good-living",
                image:"Theindigenousrecipeforlivingwell.jpg",
                imageAlt:"Colombian Indigenous groups incorporate the philosophy of Buen Vivir"
            },
            {
                heading:"Hong Kong | Cultural Traditions",
                title:"Hong Kong's guardian of the gods",
                ctaURL:"http://www.bbc.com/travel/article/20210202-hong-kongs-guardian-of-the-gods",
                image:"HongKongsguardianofthegods.jpg",
                imageAlt:"Wong and this vast outdoor shrine remain relatively unknown to most Hongkongers"
            },
            {
                heading:"India | Sustainability",
                title:"The ecologist who took on the world",
                ctaURL:"http://www.bbc.com/travel/article/20210127-vandana-shiva-on-why-the-food-we-eat-matters",
                image:"Theecologistwhotookontheworld.jpg",
                imageAlt:"For famed ecologist Vandana Shiva, what we eat is a matter of life and death"
            },
            {
                heading:"Russia | Food & Drink",
                title:"The Russian town built by apples",
                ctaURL:"http://www.bbc.com/travel/article/20210125-kolomna-the-russian-town-built-by-apple-sweets",
                image:"TheRussiantownbuiltbyapples.jpg",
                imageAlt:"Natalia Nikitina is hoping to bring back Russia's heritage apple varieties such the Arkad"
            },
            {
                heading:"Svalbard | Sustainability",
                title:"A defiant move to the Norwegian Arctic",
                ctaURL:"https://www.bbc.com/travel/article/20210120-a-defiant-move-to-the-norwegian-arctic",
                image:"AdefiantmovetotheNorwegianArctic.jpg",
                imageAlt: "During their months of isolation, the polar night produced some glorious sights"
            },
            {
                heading:"Malaysia | Food & Drink",
                title:"Malaysia’s humble ‘king of noodles’",
                ctaURL:"http://www.bbc.com/travel/article/20210118-why-noodles-are-malaysias-most-famous-street-food",
                image:"Malaysiashumblekingofnoodles.jpg",
                imageAlt:"Char kway teow is Malaysia’s most famous street food"
            },
            {
                heading:"Cuba | Culture",
                title:"The world traveller who never left home",
                ctaURL:"http://www.bbc.com/travel/article/20210114-the-bus-porter-who-travelled-the-world",
                image:"Theworldtravellerwhoneverlefthome.jpg",
                imageAlt:"Luis Martinez, Cuba's 'imaginary tourist'"
            },
            {
                heading:"Chile | Culture",
                title:"Isabel Allende on finding joy in chaos",
                ctaURL:"http://www.bbc.com/travel/article/20210112-isabel-allende-on-travel-culture-and-what-inspires-her",
                image:"IsabelAllendeonfindingjoyinchaos.jpg",
                imageAlt:"Clearing fog over mountains and the Richmond-San Rafael Bridge in San Francisco Bay"
            },
            {
                heading:"Sweden | Cultural Traditions",
                title:"A hypnotic Swedish tradition",
                ctaURL:"http://www.bbc.com/travel/article/20210106-kulning-a-hypnotic-swedish-singing-tradition",
                image:"AhypnoticSwedishtradition.jpg",
                imageAlt:"Summer farms are inextricably linked to the ancient Swedish singing tradition of kulning"
            },
            {
                heading:"Canada | Food & Drink",
                title:"Canada's Indigenous food renaissance",
                ctaURL:"http://www.bbc.com/travel/article/20210104-the-chef-preserving-canadas-indigenous-identity",
                image:"CanadasIndigenousfoodrenaissance.jpg",
                imageAlt:"Before making pikoodinigan, Nottaway always talks to her maple trees"
            }
        ]

    }
}
export default PageContent;